import { appWithTranslation, i18n, Trans, useTranslation } from 'next-i18next';

export { appWithTranslation, i18n, Trans, useTranslation };
